import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import type { FeatureKey } from '../../../../shared/features';
import { useAuth } from '../../hooks/use-auth';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { usuario, carregando } = useAuth();
  const location = useLocation();

  if (carregando) {
    return null;
  }
  if (!usuario) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}

export function RequireGuest({ children }: { children: ReactNode }) {
  const { usuario, carregando } = useAuth();

  if (carregando) {
    return null;
  }
  if (usuario) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

/** Mesmo critério de `FeatureGate` pra tela inteira; só evita expor a tela — o backend (`requireFeature`) é quem bloqueia. */
export function RequireFeature({
  feature,
  children,
}: {
  feature: FeatureKey;
  children: ReactNode;
}) {
  const { hasFeature } = useAuth();

  if (!hasFeature(feature)) {
    return (
      <div className="py-16 text-center text-muted-foreground">
        <p>Este recurso não está disponível para a sua unidade.</p>
      </div>
    );
  }

  return <>{children}</>;
}

/** Admin-only; assume que já está dentro de `RequireAuth`. Só esconde a tela — o backend (`requireAdmin`) impede a escrita. */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { usuario } = useAuth();

  if (usuario?.papel !== 'ADMIN') {
    return (
      <div className="py-16 text-center text-muted-foreground">
        <p>Esta página é restrita a administradores.</p>
      </div>
    );
  }

  return <>{children}</>;
}
